// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "passengers-3A-Um";
var _3 = "passenger-2XKa4";
export { _1 as "__esModule", _2 as "passengers", _3 as "passenger" }
export default { "__esModule": _1, "passengers": _2, "passenger": _3 }
